<template>
	<AssessmentCharacteristics class="leadership-challenge-characteristics"
		:is-skeleton="isSkeleton"
		:high-type="highType"
		:characteristics="characteristics"
	>
		<template #icon>
			<FontAwesomeIcon
				:icon="[ `far`, `triangle-exclamation` ]"
			/>
		</template>
		<template #heading>{{ $t( "common.LeadershipChallengeCharacteristics__heading" ) }}</template>
	</AssessmentCharacteristics>
</template>

<script>
import CommonCharacteristics from "./CommonCharacteristicsProps";
import AssessmentCharacteristics from "./AssessmentCharacteristics";
export default {
	name: "LeadershipChallengeCharacteristics",
	mixins: [ CommonCharacteristics, ],
	components: {
		AssessmentCharacteristics,
	},
	computed: {
		characteristics() {
			return this.assessment?.teamingContent?.leader?.challenges || [];
		},
	},
};
</script>

<style lang="scss" scoped></style>
